import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Container,
  ContainerHeader,
  ContainerResult,
  Divider,
  Text,
} from './styles';

const ResultsBox = (props) => {
  const {
    resultType,
    directColor,
    indirectColor,
    directResult,
    indirectResult,
  } = props;

  const { total: directTotal, percentage: directPercentage } = directResult;
  const { total: indirectTotal, percentage: indirectPercentage } = indirectResult;

  const totalValue = `Total ${resultType} ${directTotal + indirectTotal} (${directPercentage + indirectPercentage}%)`;

  return (
    <Container>
      <ContainerHeader>{resultType}</ContainerHeader>

      <ContainerResult>
        <Box color={directColor} />
        <Text>{`Direct ${resultType} ${directTotal} (${directPercentage}%)`}</Text>
      </ContainerResult>

      <ContainerResult>
        <Box color={indirectColor} />
        <Text>{`Indirect ${resultType} ${indirectTotal} (${indirectPercentage}%)`}</Text>
      </ContainerResult>

      <Divider />

      <ContainerResult>
        <Box
          multicolor={[directColor, indirectColor]}
        />
        <Text>{totalValue}</Text>
      </ContainerResult>
    </Container>
  );
};

ResultsBox.propTypes = {
  resultType: PropTypes.string.isRequired,
  directColor: PropTypes.string.isRequired,
  indirectColor: PropTypes.string.isRequired,
  directResult: PropTypes.shape({
    percentage: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  indirectResult: PropTypes.shape({
    percentage: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
};

export default ResultsBox;
